import React from "react";
import { useTranslation } from "react-i18next";

import WindowWrapper from "../components/WindowWrapper";

function InputScreen(props) {
  const { t } = useTranslation();

  return (
    <WindowWrapper
      t={t}
      generateFlexLayoutJson={() => ({
        global: {
          tabEnableRename: true,
          tabSetEnableClose: true,
        },
        borders: [
          {
            type: "border",
            location: "top",
            barSize: 64,
            children: [],
          },
        ],
        layout: {
          type: "row",
          children: [
            {
              type: "row",
              children: [
                {
                  type: "tabset",
                  weight: 70,
                  children: [
                    {
                      type: "tab",
                      name: t("tree"),
                      component: "nodeTree",
                      config: {
                        search: true,
                        loading: false,
                        useVersionInRequests: false,
                        disableRootChange: true,
                        treeRoot: "tables",
                      },
                    },
                  ],
                },
                {
                  type: "tabset",
                  weight: 30,
                  children: [
                    {
                      type: "tab",
                      name: t("tree"),
                      component: "nodeTree",
                      config: {
                        isOpenByDefault: true,
                        search: false,
                        loading: false,
                        useVersionInRequests: false,
                        treeRoot: "tmp",
                        disableRootFetch: true,
                        disableSettings: true,
                        disableOpennessStatePersist: true,
                        useRootPath: true,
                        nodeFormConfig: {
                          disableEditing: true,
                        },
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: "tabset",
              children: [
                {
                  id: "nodeForm",
                  type: "tab",
                  name: "",
                  component: "node",
                  enableClose: false,
                  config: {
                    renderTable: true,
                  },
                },
              ],
            },
          ],
        },
      })}
    />
  );
}

export default InputScreen;
